// スクロールアニメーション
document.addEventListener('DOMContentLoaded', () => {
	const elements = document.querySelectorAll('.animation');

	// .jp_title 内のテキストを1文字ずつ span 化（既存の葉spanはそのまま）
	const wrapJpTitleChars = (title) => {
		const walk = (node) => {
			if (node.nodeType === Node.TEXT_NODE) {
				const text = node.textContent;
				if (!text || !/[^\s]/.test(text)) return;

				const frag = document.createDocumentFragment();
				for (const char of text) {
					if (char === '\n' || char === '\r') continue;
					if (/\s/.test(char)) {
						frag.appendChild(document.createTextNode(char));
						continue;
					}
					const span = document.createElement('span');
					span.textContent = char;
					frag.appendChild(span);
				}
				node.parentNode?.replaceChild(frag, node);
				return;
			}

			if (node.nodeType !== Node.ELEMENT_NODE) return;
			// すでに1文字用の葉 span なら再ラップしない
			if (node.tagName === 'SPAN' && node.children.length === 0) return;

			[...node.childNodes].forEach(walk);
		};

		walk(title);
	};

	// titleBox の1文字ずつアニメーション用に順番を付与
	document.querySelectorAll('.titleBox.animation').forEach((box) => {
		const title = box.querySelector('.jp_title');
		if (title) wrapJpTitleChars(title);

		const chars = [...box.querySelectorAll('.jp_title span')].filter(
			(span) => span.children.length === 0 && span.textContent.trim().length > 0
		);
		chars.forEach((span, index) => {
			span.style.setProperty('--char-i', String(index));
		});
	});

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('animation--show');
				observer.unobserve(entry.target);
			}
		});
	}, {
		root: null,
		rootMargin: '0px 0px -20% 0px',
		threshold: 0
	});

	elements.forEach(el => observer.observe(el));

	// #top のみ：titleBoxアニメ完了後に全体を表示
	if (document.body.id === 'top') {
		const finishIntro = () => {
			document.body.classList.remove('is-intro');
			document.body.classList.add('is-intro-done');
		};

		const introTitle = document.querySelector('#top_main .titleBox.animation');
		if (!introTitle) {
			finishIntro();
		} else {
			const chars = [...introTitle.querySelectorAll('.jp_title span')].filter(
				(span) => span.children.length === 0 && span.textContent.trim().length > 0
			);
			const duration = 800;
			const stagger = 50;
			const total = duration + Math.max(chars.length - 1, 0) * stagger;

			document.body.classList.add('is-intro');
			window.scrollTo(0, 0);
			introTitle.classList.add('animation--show');
			setTimeout(finishIntro, total);
		}
	}
});

// top_slides 無限カルーセル
(() => {
	const root = document.querySelector('.top_slides');
	const track = document.querySelector('.top_slides_track');
	if (!root || !track) return;

	const prevBtn = document.querySelector('.top_slides_prev');
	const nextBtn = document.querySelector('.top_slides_next');
	const stopBtn = document.querySelector('.top_slides_stop');
	const duration = 50; // 秒（1セット分）
	// const leftOffsetRatio = 56 / 1440;
	const leftOffsetRatio = 0;
	const enterDuration = 550;
	const enterStagger = 120;
	let isPlaying = true;
	let isHovering = false;
	let isBusy = false;
	let isEntering = true;
	let hoverItem = null;

	// ループ用にスライドを複製
	const originalCount = track.querySelectorAll('.top_slides_item').length;
	track.innerHTML = track.innerHTML + track.innerHTML;

	const items = () => [...track.querySelectorAll('.top_slides_item')];
	const halfWidth = () => track.scrollWidth / 2;
	const slideWidth = () => {
		const base = items().find((item) => !item.classList.contains('is-hover')) || items()[0];
		if (!base) return 0;
		return base.classList.contains('is-hover') ? base.offsetWidth / 1.5 : base.offsetWidth;
	};

	const normalizeX = (x) => {
		const half = halfWidth();
		if (half <= 0) return x;
		while (x <= -half) x += half;
		while (x > 0) x -= half;
		return x;
	};

	const getCurrentX = () => {
		const style = getComputedStyle(track);
		if (style.transform && style.transform !== 'none') {
			return new DOMMatrixReadOnly(style.transform).m41;
		}
		return 0;
	};

	const freezeAtCurrent = () => {
		const x = getCurrentX();
		track.style.animation = 'none';
		track.style.transform = `translateX(${x}px)`;
		track.classList.add('is-paused');
		return x;
	};

	const applyAnimationFromX = (x) => {
		const half = halfWidth();
		const progress = half > 0 ? (-normalizeX(x) / half) : 0;
		track.style.animation = 'none';
		track.style.transform = `translateX(${normalizeX(x)}px)`;
		void track.offsetWidth;
		track.style.transform = '';
		track.style.animation = `topSlidesMarquee ${duration}s linear infinite`;
		track.style.animationDelay = `${-progress * duration}s`;
		track.classList.toggle('is-paused', !(isPlaying && !isHovering && !isEntering));
	};

	const shouldAnimate = () => isPlaying && !isHovering && !isBusy && !isEntering;

	// 初期位置だけセットし、自動スクロールは入場完了まで待つ（1枚目から）
	const startX = () => -(window.innerWidth * leftOffsetRatio);
	track.style.animation = 'none';
	track.style.transform = `translateX(${startX()}px)`;
	track.classList.add('is-paused');

	const setPlaying = (playing) => {
		isPlaying = playing;
		track.classList.toggle('is-paused', !shouldAnimate());
		if (!stopBtn) return;
		stopBtn.classList.toggle('is-playing', playing);
		stopBtn.setAttribute('aria-label', playing ? '停止' : '再生');
		stopBtn.setAttribute('aria-pressed', playing ? 'false' : 'true');
	};

	const startAutoScroll = () => {
		isEntering = false;
		if (isPlaying && !isHovering) {
			applyAnimationFromX(startX());
		}
	};

	const playEntrance = () => {
		const list = items();
		for (let i = 0; i < originalCount; i += 1) {
			const delay = i * enterStagger;
			setTimeout(() => {
				list[i]?.classList.add('is-entered');
				list[i + originalCount]?.classList.add('is-entered');
			}, delay);
		}

		const total = Math.max(originalCount - 1, 0) * enterStagger + enterDuration;
		setTimeout(startAutoScroll, total);
	};

	const watchIntroDone = () => {
		if (document.body.id !== 'top') {
			playEntrance();
			return;
		}

		if (document.body.classList.contains('is-intro-done')) {
			playEntrance();
			return;
		}

		const observer = new MutationObserver(() => {
			if (!document.body.classList.contains('is-intro-done')) return;
			observer.disconnect();
			playEntrance();
		});
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
	};

	watchIntroDone();

	stopBtn?.addEventListener('click', () => {
		if (isEntering) return;
		if (isPlaying) {
			freezeAtCurrent();
			setPlaying(false);
		} else {
			isPlaying = true;
			if (!isHovering) {
				applyAnimationFromX(getCurrentX());
			} else {
				track.classList.add('is-paused');
			}
			stopBtn.classList.add('is-playing');
			stopBtn.setAttribute('aria-label', '停止');
			stopBtn.setAttribute('aria-pressed', 'false');
		}
	});

	const shiftSiblingBefore = (item, enable) => {
		const pushItems = [];
		let prev = item.previousElementSibling;
		while (prev) {
			pushItems.push(prev);
			prev = prev.previousElementSibling;
		}

		const count = pushItems.length;
		pushItems.forEach((el) => {
			if (enable && count > 0) {
				el.classList.add('is-hover-push');
				el.style.setProperty('--hover-push-count', count);
			} else {
				el.classList.remove('is-hover-push');
				el.style.removeProperty('--hover-push-count');
			}
		});
	};

	const onItemEnter = (item) => {
		if (isBusy || isEntering) return;
		isHovering = true;
		hoverItem = item;
		freezeAtCurrent();
		shiftSiblingBefore(item, true);
		item.classList.add('is-hover');
		track.classList.add('is-hover');
	};
	const onItemLeave = (item) => {
		if (hoverItem !== item) return;
		item.classList.remove('is-hover');
		track.classList.remove('is-hover');
		shiftSiblingBefore(item, false);
		hoverItem = null;
		isHovering = false;

		const resume = () => {
			if (isHovering || isBusy || isEntering) return;
			if (isPlaying) {
				applyAnimationFromX(getCurrentX());
			}
		};

		const onWidthEnd = (event) => {
			if (event.propertyName && event.propertyName !== 'width') return;
			item.removeEventListener('transitionend', onWidthEnd);
			resume();
		};

		item.addEventListener('transitionend', onWidthEnd);
		setTimeout(() => {
			item.removeEventListener('transitionend', onWidthEnd);
			resume();
		}, 450);
	};

	items().forEach((item) => {
		item.addEventListener('mouseenter', () => onItemEnter(item));
		item.addEventListener('mouseleave', () => onItemLeave(item));
	});

	const shiftBy = (dir) => {
		if (isBusy || isHovering || isEntering) return;
		isBusy = true;

		const half = halfWidth();
		const delta = slideWidth() || 0;
		let from = normalizeX(getCurrentX());

		// prev は左側に複製側の余白を確保するため、同一見た目の位置へ先に寄せる
		if (dir === 'prev') {
			from -= half;
		}

		// 遷移中は正規化せず、複製スライド側へ連続移動させる
		const to = from + (dir === 'next' ? -delta : delta);

		track.classList.add('is-paused');
		track.style.animation = 'none';
		track.style.transition = '';
		track.style.transform = `translateX(${from}px)`;
		void track.offsetWidth;
		track.style.transition = 'transform 0.6s ease';
		track.style.transform = `translateX(${to}px)`;

		const finish = () => {
			if (!isBusy) return;
			isBusy = false;
			track.style.transition = '';
			// アニメ再開時だけループ位置へ正規化
			if (isPlaying && !isHovering) {
				applyAnimationFromX(to);
			} else {
				track.style.animation = 'none';
				track.style.transform = `translateX(${normalizeX(to)}px)`;
				track.classList.add('is-paused');
			}
		};

		track.addEventListener('transitionend', finish, { once: true });
		setTimeout(finish, 700);
	};

	prevBtn?.addEventListener('click', () => shiftBy('prev'));
	nextBtn?.addEventListener('click', () => shiftBy('next'));

	window.addEventListener('resize', () => {
		if (isEntering) {
			track.style.transform = `translateX(${startX()}px)`;
			return;
		}
		if (isHovering) {
			freezeAtCurrent();
			return;
		}
		applyAnimationFromX(getCurrentX());
	});
})();

// ニュースタブ切り替え
(() => {
	const menu = document.querySelector('#news_menu');
	const tabs = document.querySelector('#news_tabs');
	if (!menu || !tabs) return;

	const menuItems = [...menu.children];
	const tabItems = [...tabs.children];
	const buttonLists = [...document.querySelectorAll('.news_button')];
	const duration = 350;
	let isAnimating = false;

	const setActiveMenu = (index) => {
		menuItems.forEach((item, i) => {
			item.classList.toggle('active', i === index);
		});
	};

	const fadePair = (current, next, onDone) => {
		if (!current || current === next) {
			if (next) next.classList.add('active');
			onDone?.();
			return;
		}

		let finished = false;
		let fadedOut = false;
		const complete = () => {
			if (finished) return;
			finished = true;
			onDone?.();
		};

		current.classList.add('is-animating', 'is-hiding');

		const finishFadeOut = () => {
			if (fadedOut) return;
			fadedOut = true;
			current.classList.remove('active', 'is-animating', 'is-hiding');

			if (!next) {
				complete();
				return;
			}

			next.classList.add('active', 'is-animating');
			next.style.opacity = '0';

			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					next.style.opacity = '';
				});
			});

			const finishFadeIn = () => {
				next.classList.remove('is-animating');
				complete();
			};

			const onFadeIn = (event) => {
				if (event.propertyName !== 'opacity') return;
				next.removeEventListener('transitionend', onFadeIn);
				finishFadeIn();
			};

			next.addEventListener('transitionend', onFadeIn);
			setTimeout(() => {
				next.removeEventListener('transitionend', onFadeIn);
				finishFadeIn();
			}, duration + 50);
		};

		const onFadeOut = (event) => {
			if (event.propertyName !== 'opacity') return;
			current.removeEventListener('transitionend', onFadeOut);
			finishFadeOut();
		};

		current.addEventListener('transitionend', onFadeOut);
		setTimeout(() => {
			if (!current.classList.contains('is-hiding')) return;
			current.removeEventListener('transitionend', onFadeOut);
			finishFadeOut();
		}, duration + 50);
	};

	const switchTab = (index) => {
		if (isAnimating || index < 0 || index >= tabItems.length) return;

		const currentTab = tabs.querySelector(':scope > li.active');
		const nextTab = tabItems[index];
		const buttonPairs = buttonLists.map((list) => ({
			current: list.querySelector(':scope > li.active'),
			next: list.children[index] || null,
		}));

		if (currentTab === nextTab) {
			setActiveMenu(index);
			return;
		}

		isAnimating = true;
		setActiveMenu(index);

		let pending = 1 + buttonPairs.length;
		const done = () => {
			pending -= 1;
			if (pending <= 0) isAnimating = false;
		};

		fadePair(currentTab, nextTab, done);
		buttonPairs.forEach(({ current, next }) => fadePair(current, next, done));
	};

	menuItems.forEach((item, index) => {
		item.addEventListener('click', () => switchTab(index));
	});
})();

// スムーススクロール
function scrollWindowToY(top, behavior = 'smooth') {
	const y = Math.max(0, top);
	const scrollingElement = document.scrollingElement || document.documentElement;

	if (typeof scrollingElement.scrollTo === 'function') {
		scrollingElement.scrollTo({ top: y, behavior });
		return;
	}

	window.scrollTo({ top: y, behavior });
}

function getCurrentScrollTop() {
	return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function scrollToTargetWithOffset(target) {
	const FIXED_OFFSET = 100;
	const targetY = target.getBoundingClientRect().top + getCurrentScrollTop() - FIXED_OFFSET;
	scrollWindowToY(targetY, 'smooth');
}

function smoothScrollToHashHref(href) {
	if (!href || href === '#') {
		scrollWindowToY(0, 'smooth');
		if (window.location.hash) {
			history.replaceState(null, '', window.location.pathname + window.location.search);
		}
		return true;
	}

	if (!href.startsWith('#')) {
		return false;
	}

	const id = decodeURIComponent(href.slice(1));
	if (!id) {
		return false;
	}

	const target = document.getElementById(id);
	if (!target) {
		return false;
	}

	setTimeout(() => {
		scrollToTargetWithOffset(target);
	}, 100);
	return true;
}

function smoothScrollToLocationHashIfPresent() {
	const raw = window.location.hash;

	if (!raw || raw === '#') {
		return;
	}

	const id = decodeURIComponent(raw.slice(1));
	if (!id) {
		return;
	}

	const target = document.getElementById(id);
	if (!target) {
		return;
	}

	history.scrollRestoration = 'manual';
	window.scrollTo(0, 0);

	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			setTimeout(() => {
				scrollToTargetWithOffset(target);
			}, 100);
		});
	});
}

window.addEventListener('load', () => {
	smoothScrollToLocationHashIfPresent();
});

document.addEventListener('click', (e) => {
	const link = e.target.closest('a[href^="#"]');
	if (!link) return;

	const href = link.getAttribute('href');
	if (!href) return;

	e.preventDefault();
	smoothScrollToHashHref(href);
});

// オーバーレイ型カスタムスクロールバー
(() => {
	const track = document.createElement('div');
	track.className = 'scrollbar';
	track.innerHTML = '<div class="scrollbar__thumb"></div>';
	document.body.appendChild(track);

	const thumb = track.querySelector('.scrollbar__thumb');
	let dragging = false;
	let dragStartY = 0;
	let dragStartScroll = 0;

	const getMetrics = () => {
		const scrollTop = window.scrollY || document.documentElement.scrollTop;
		const viewHeight = window.innerHeight;
		const docHeight = document.documentElement.scrollHeight;
		const maxScroll = Math.max(docHeight - viewHeight, 0);
		const thumbHeight = maxScroll > 0
			? Math.max((viewHeight / docHeight) * viewHeight, 40)
			: viewHeight;
		const thumbTravel = Math.max(viewHeight - thumbHeight, 0);
		const thumbTop = maxScroll > 0 ? (scrollTop / maxScroll) * thumbTravel : 0;

		return { maxScroll, thumbHeight, thumbTravel, thumbTop };
	};

	const update = () => {
		const { maxScroll, thumbHeight, thumbTop } = getMetrics();

		if (maxScroll <= 0) {
			track.classList.remove('is-visible');
			return;
		}

		thumb.style.height = `${thumbHeight}px`;
		thumb.style.transform = `translateY(${thumbTop}px)`;
		track.classList.add('is-visible');
	};

	const onPointerMove = (event) => {
		if (!dragging) return;
		const { maxScroll, thumbTravel } = getMetrics();
		if (maxScroll <= 0 || thumbTravel <= 0) return;

		const deltaY = event.clientY - dragStartY;
		const nextScroll = dragStartScroll + (deltaY / thumbTravel) * maxScroll;
		window.scrollTo(0, Math.min(Math.max(nextScroll, 0), maxScroll));
	};

	const stopDrag = () => {
		if (!dragging) return;
		dragging = false;
		thumb.classList.remove('is-dragging');
		document.body.style.userSelect = '';
		update();
	};

	thumb.addEventListener('pointerdown', (event) => {
		event.preventDefault();
		dragging = true;
		dragStartY = event.clientY;
		dragStartScroll = window.scrollY || document.documentElement.scrollTop;
		thumb.classList.add('is-dragging');
		document.body.style.userSelect = 'none';
		thumb.setPointerCapture(event.pointerId);
	});

	thumb.addEventListener('pointermove', onPointerMove);
	thumb.addEventListener('pointerup', stopDrag);
	thumb.addEventListener('pointercancel', stopDrag);

	track.addEventListener('pointerdown', (event) => {
		if (event.target !== track) return;
		const { maxScroll, thumbHeight, thumbTravel } = getMetrics();
		if (maxScroll <= 0 || thumbTravel <= 0) return;

		const clickY = event.clientY - thumbHeight / 2;
		const ratio = Math.min(Math.max(clickY / thumbTravel, 0), 1);
		window.scrollTo(0, ratio * maxScroll);
	});

	window.addEventListener('scroll', update, { passive: true });
	window.addEventListener('resize', update);
	window.addEventListener('load', update);
	update();
})();

// ヘッダーメガメニュー
(() => {
	const header = document.querySelector('#header');
	const overlay = document.querySelector('.header_overlay');
	const h_top_logo = document.querySelector('.h_top_logo');
	if (!header || !overlay) return;

	const mq = window.matchMedia('(min-width: 960px)');
	const isPc = () => mq.matches;

	const menuItems = [...header.querySelectorAll('.h_nav > ul > li')].filter((li) =>
		li.querySelector(':scope > .menu')
	);

	const closeMenu = () => {
		menuItems.forEach((li) => li.classList.remove('is-open'));
		if (isPc() || !header.classList.contains('is-nav-open')) {
			overlay.classList.remove('is-active');
			h_top_logo.classList.remove('is-hidden');
		}
	};

	const openMenu = (target) => {
		menuItems.forEach((li) => {
			li.classList.toggle('is-open', li === target);
		});
		if (isPc() || header.classList.contains('is-nav-open')) {
			overlay.classList.add('is-active');
			h_top_logo.classList.add('is-hidden');
		} else {
			overlay.classList.remove('is-active');
			h_top_logo.classList.remove('is-hidden');
		}
	};

	const toggleMenu = (target) => {
		if (target.classList.contains('is-open')) {
			closeMenu();
		} else {
			openMenu(target);
		}
	};

	menuItems.forEach((li) => {
		li.addEventListener('mouseenter', () => {
			if (!isPc()) return;
			openMenu(li);
		});

		const trigger = li.querySelector(':scope > a');
		trigger?.addEventListener('click', (event) => {
			if (isPc()) return;
			event.preventDefault();
			toggleMenu(li);
		});
	});

	header.querySelectorAll('.h_nav > ul > li').forEach((li) => {
		if (menuItems.includes(li)) return;
		li.addEventListener('mouseenter', () => {
			if (!isPc()) return;
			closeMenu();
		});
	});

	header.addEventListener('mouseleave', () => {
		if (!isPc()) return;
		closeMenu();
	});

	overlay.addEventListener('mouseenter', () => {
		if (!isPc()) return;
		closeMenu();
	});

	mq.addEventListener('change', closeMenu);
})();

// スマホ：ハンバーガーで .h_nav を開閉
(() => {
	const header = document.querySelector('#header');
	const btn = document.querySelector('#h_nav_btn');
	const nav = document.querySelector('.h_nav');
	const overlay = document.querySelector('.header_overlay');
	if (!header || !btn || !nav || !overlay) return;

	const mq = window.matchMedia('(min-width: 960px)');
	let scrollY = 0;

	const lockScroll = () => {
		scrollY = window.scrollY;
		document.body.style.position = 'fixed';
		document.body.style.top = `-${scrollY}px`;
		document.body.style.left = '0';
		document.body.style.right = '0';
		document.body.style.width = '100%';
	};

	const unlockScroll = () => {
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.left = '';
		document.body.style.right = '';
		document.body.style.width = '';
		window.scrollTo(0, scrollY);
	};

	const closeNav = () => {
		if (!header.classList.contains('is-nav-open')) return;
		header.classList.remove('is-nav-open');
		btn.setAttribute('aria-expanded', 'false');
		overlay.classList.remove('is-active');
		unlockScroll();
		header.querySelectorAll('.h_nav > ul > li.is-open').forEach((li) => {
			li.classList.remove('is-open');
		});
	};

	const openNav = () => {
		header.classList.add('is-nav-open');
		overlay.classList.add('is-active');
		btn.setAttribute('aria-expanded', 'true');
		lockScroll();
	};

	btn.setAttribute('aria-expanded', 'false');
	btn.setAttribute('aria-label', 'メニュー');

	btn.addEventListener('click', () => {
		if (mq.matches) return;
		if (header.classList.contains('is-nav-open')) {
			closeNav();
		} else {
			openNav();
		}
	});

	mq.addEventListener('change', () => {
		if (mq.matches) closeNav();
	});
})();

// .h_top_logo スクロールで非表示
(() => {
	const logo = document.querySelector('.h_top_logo');
	if (!logo) return;

	const update = () => {
		logo.classList.toggle('is-hidden', window.scrollY > 1);
	};

	window.addEventListener('scroll', update, { passive: true });
	update();
})();

// #top_fixedBn 300px超でフェードアウト
(() => {
	const bn = document.querySelector('#top_fixedBn');
	if (!bn) return;

	const threshold = 300;
	const update = () => {
		bn.classList.toggle('is-hidden', window.scrollY >= threshold);
	};

	window.addEventListener('scroll', update, { passive: true });
	update();
})();

// ブログ記事のシェアボタン（URLコピー）用
(() => {
	const buttons = document.querySelectorAll('.js-copy-url');
	if (!buttons.length) return;

	const copyText = async (text) => {
		if (navigator.clipboard?.writeText && window.isSecureContext) {
			await navigator.clipboard.writeText(text);
			return;
		}

		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.setAttribute('readonly', '');
		textarea.style.position = 'fixed';
		textarea.style.opacity = '0';
		document.body.appendChild(textarea);
		textarea.select();
		const ok = document.execCommand('copy');
		textarea.remove();
		if (!ok) throw new Error('copy failed');
	};

	buttons.forEach((button) => {
		button.addEventListener('click', async (event) => {
			event.preventDefault();
			try {
				await copyText(location.href);
				alert('URLをコピーしました。');
			} catch (error) {
				alert('URLのコピーに失敗しました。');
			}
		});
	});
})();

// PCサイドバー：画面より高いときスクロール追従を調整
(() => {
	const OVER_SIZE = 'is-overSize';
	const GAP = 32; // ヘッダー下の余白
	const mq = window.matchMedia('(min-width: 960px)');
	const aside = document.querySelector('.blogSideBar.pc .blogSideBar_inner, .col2_sideBar.pc .col2_sideBar_inner');
	const header = document.querySelector('#header');
	if (!aside || !header) return;

	let scrollY = 0;
	let prevScrollY = 0;
	let headerHeight = 0;
	let asideHeight = 0;
	let headerTop = 0;
	let moveVal = 0;

	const rect = (el) => el.getBoundingClientRect();

	const readSizes = () => {
		headerHeight = rect(header).height;
		asideHeight = rect(aside).height;
		headerTop = headerHeight + GAP;
	};

	const setStickyTop = (value) => {
		aside.style.setProperty('--sticky-top', `${value}px`);
	};

	const init = () => {
		if (!mq.matches) {
			aside.classList.remove(OVER_SIZE);
			aside.style.removeProperty('--sticky-top');
			moveVal = 0;
			prevScrollY = 0;
			return;
		}

		readSizes();
		setStickyTop(headerTop);
		aside.classList.toggle(OVER_SIZE, window.innerHeight < asideHeight + headerTop);
		if (!aside.classList.contains(OVER_SIZE)) {
			moveVal = 0;
			prevScrollY = 0;
		}
	};

	const onScroll = () => {
		if (!mq.matches || !aside.classList.contains(OVER_SIZE)) return;

		scrollY = window.scrollY || window.pageYOffset;
		const asideTop = rect(aside).top - headerTop;

		if (asideTop <= 0) {
			const delta = scrollY - (prevScrollY || 0);
			prevScrollY = scrollY;
			moveVal = (moveVal || 0) - delta;

			const max = headerTop;
			const min = -(asideHeight - (window.innerHeight - GAP));
			moveVal = Math.min(Math.max(moveVal, min), max);
			setStickyTop(moveVal);
		} else {
			setStickyTop(headerTop);
			moveVal = headerTop;
			prevScrollY = scrollY;
		}
	};

	window.initBlogSidebarSticky = init;

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', init);
	mq.addEventListener('change', init);
	init();

	if (window.__blogCorpTagsPendingStickyInit) {
		init();
		window.__blogCorpTagsPendingStickyInit = false;
	}
})();

// 事例カード：スマホのみ中央寄せスライダー
(() => {
	const slider = document.querySelector('.case-articles__slider');
	const list = slider?.querySelector('.case-articles__cardList');
	if (!slider || !list || typeof Swiper === 'undefined') return;

	const mq = window.matchMedia('(max-width: 959px)');
	let swiper = null;

	const spaceBetween = () => Math.round(window.innerWidth * (16 / 375));

	const mount = () => {
		if (swiper || !mq.matches) return;
		list.classList.add('swiper-wrapper');
		list.querySelectorAll(':scope > .case-articles__item').forEach((item) => {
			item.classList.add('swiper-slide');
		});
		const slideCount = list.querySelectorAll(':scope > .case-articles__item').length;
		slider.classList.add('swiper');
		swiper = new Swiper(slider, {
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: spaceBetween(),
			speed: 400,
			loop: true,
			loopedSlides: slideCount,
			loopAdditionalSlides: 1,
			navigation: {
				nextEl: slider.parentElement.querySelector('.case-articles__next'),
				prevEl: slider.parentElement.querySelector('.case-articles__prev'),
			},
		});
	};

	const unmount = () => {
		if (!swiper) return;
		swiper.destroy(true, true);
		swiper = null;
		slider.classList.remove('swiper');
		list.classList.remove('swiper-wrapper');
		list.querySelectorAll('.swiper-slide-duplicate').forEach((el) => el.remove());
		list.querySelectorAll('.case-articles__item').forEach((item) => {
			item.classList.remove('swiper-slide');
		});
	};

	const update = () => {
		if (mq.matches) {
			mount();
			if (swiper) {
				swiper.params.spaceBetween = spaceBetween();
				swiper.update();
			}
		} else {
			unmount();
		}
	};

	mq.addEventListener('change', update);
	window.addEventListener('resize', update);
	update();
})();
